import styled from 'styled-components';

// Components
import { Container, ContainerButton } from '../components/MainStyledComponents';

// Fix responsive (tabs de módulo Campañas, 2026-07-14): dentro del wrapper
// Tabs+Outlet (GeneralViewCampaign, `align-items: flex-start`) el `Container`
// compartido encogía al contenido (~992px con media pantalla vacía). Igual que
// las páginas hermanas del GeneralView de O.T., la página declara su ancho.
export const ContainerStyled = styled(Container)`
  width: 100%;
`;

export const ContainerButtonStyled = styled(ContainerButton)`
  align-items: flex-end;
  @media (max-width: ${({ theme }) =>
      theme.breakPoints.landscapeTablet * theme.percentBaseResponsive}rem) {
    display: flex;
    justify-content: center;
    margin-top: ${({ theme }) => theme.spacing.xxxl};
  }
  @media (max-width: ${({ theme }) =>
      theme.breakPoints.portraitTablet * theme.percentBaseResponsive}rem) {
    flex-direction: column;
    align-items: center;
    gap: ${({ theme }) => theme.spacing.xl};
  }
`;

export const ContainerButtonSmall = styled(ContainerButton)`
  margin-top: 0;
`;
